module.exports = __webpack_public_path__ + "static/media/buxton-7.aa8921c8.jpg";